import { z } from 'zod';

/** Roles are derived from rows, never stored on the person (PLAN §2.3). */
export const ROLES = ['admin', 'dpa', 'master', 'officer'] as const;
export type Role = (typeof ROLES)[number];
export const roleSchema = z.enum(ROLES);
